var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 100,
    viewBox: "0 0 87 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3013 0L86.6026 25V75L43.3013 100L0 75V25L43.3013 0Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6411 0L86.9424 25V75L43.6411 100L43.6411 75V25L43.6411 0Z",
    fill: "#336589"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9028 47.8042H24.6167C24.0779 47.8042 23.6411 47.3778 23.6411 46.8518V30.9524C23.6411 30.4264 24.0779 30 24.6167 30H28.5188C29.0576 30 29.4944 30.4264 29.4944 30.9524V37.1517C33.2155 33.1174 38.6206 30.5929 44.6296 30.6355C55.7594 30.7144 64.6647 39.4944 64.6411 50.3602C64.6174 61.211 55.6 70 44.4798 70C39.2697 70 34.5215 68.0704 30.9433 64.9036C30.5288 64.5367 30.5097 63.9072 30.9054 63.521L33.6667 60.8252C34.0304 60.4702 34.6148 60.4509 35.0001 60.7836C37.5231 62.9632 40.8416 64.2857 44.4798 64.2857C52.3873 64.2857 58.7879 58.0384 58.7879 50.3175C58.7879 42.5979 52.3886 36.3492 44.4798 36.3492C39.7244 36.3492 35.5146 38.6092 32.9136 42.0899H40.9028C41.4416 42.0899 41.8784 42.5163 41.8784 43.0423V46.8518C41.8784 47.3778 41.4416 47.8042 40.9028 47.8042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoModalIcon);
export default __webpack_public_path__ + "static/media/undo-modal-icon.6d0f5f90f659a78331d29bf94c1142f3.svg";
export { ForwardRef as ReactComponent };